<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card
          color="indigo"
          icon="mdi-chair-school"
          title="Create course"
          class="px-5 py-3"
        >
          <v-form ref="form" class="mt-5">
            <v-autocomplete
              v-model="item.teacherIds"
              label="Teacher"
              :items="teachers"
              item-text="name"
              item-value="id"
              multiple
            />

            <v-autocomplete
              v-model="item.trainingTemplateId"
              :rules="[rules.required]"
              label="Template"
              :items="templates"
              item-text="description"
              item-value="id"
            />

            <v-datetime-picker
              label="Start"
              v-model="item.start"
              :rules="[rules.required]"
              :time-picker-props="timeProps"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-calendar-clock</v-icon>
              </template>
            </v-datetime-picker>
            <v-datetime-picker
              label="End"
              v-model="item.end"
              :rules="[rules.required]"
              :time-picker-props="timeProps"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-calendar-clock</v-icon>
              </template>
            </v-datetime-picker>

            <v-text-field v-model="item.adressExtraInfo" label="Adress Extra" />
            <v-text-field v-model="item.adress" label="Adress" :rules="[rules.required]" />
            <v-text-field v-model="item.zipCode" label="Zip Code" :rules="[rules.required]" />
            <v-text-field v-model="item.city" label="City" :rules="[rules.required]" />
            <v-text-field
              v-model.number="item.availableSeats"
              :rules="[rules.required]"
              label="Seats"
            />

            <v-textarea v-model="item.description" name="input-7-1" label="Description"></v-textarea>

            <v-switch v-model="item.public" label="Public"></v-switch>
            <v-file-input
              class="mb-2"
              :rules="[rules.required]"
              v-bind:success="uploadStatus"
              v-bind:success-messages="uploadText"
              @change="onChangedImage"
              v-model="selectedImage"
              accept="image/*"
              label="File input"
              show-size
            ></v-file-input>
            <v-btn class="mb-5" @click="onUpload">Upload</v-btn>
          </v-form>
          <v-row justify="center">
            <v-card-actions class="pl-0">
              <v-btn @click="create()" color="success" min-width="100">Submit</v-btn>
            </v-card-actions>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <div class="text-center ma-2">
      <v-snackbar v-model="Snackbar.visible" :timeout="Snackbar.timeout" :color="Snackbar.color">
        {{ Snackbar.snackbarText }}
        <v-btn dark text @click="Snackbar.visible = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import TrainingApi from "../../../servcies/api/training/Training";
import TemplateApi from "../../../servcies/api/training/TrainingTemplate";
import TrainingTemplate from "../../../servcies/api/training/TrainingTemplate";
import FileApi from "../../../servcies/api/File";
import router from "../../../router";

var now = new Date().toISOString().split(".")[0] + "Z";

export default {
  name: "TrainingCreate",
  data: () => ({
    item: {
      id: -1,
      dateFrom: "",
      dateTo: "",
      adress: "",
      adressExtraInfo: "",
      city: "",
      zipCode: "",
      availableSeats: null,
      teacherId: 0,
      teacherIds: [],
      trainingTemplateId: 0,
      public: false,
      imageExtId: "",
      imagePath: "",
      description: "",
      start: new Date(now),
      end: new Date(now)
    },
    Snackbar: {
      snackbarText: "",
      visible: false,
      timeout: 5000,
      color: "error"
    },

    rules: {
      required: value => !!value || "Required."
    },

    teachers: [],
    templates: [],

    timeProps: {
      format: "24hr"
    },

    selectedImage: null,
    uploadStatus: false,
    uploadText: ""
  }),

  created() {
    this.init();
  },
  methods: {
    onChangedImage() {
      this.uploadStatus = false;
      this.uploadText = "";
    },
    onUpload() {
      if (this.selectedImage == null) return;

      if (!this.selectedImage.type.includes("image")) {
        this.Snackbar.snackbarText = "Only images are allowed.";
        this.Snackbar.visible = true;
      }

      var fileData = new FormData();
      fileData.append("file", this.selectedImage, this.selectedImage.name);

      FileApi.upload(fileData)
        .then(result => {
          //Set the guid to the image
          this.item.imageExtId = result.externalId;
          this.item.imagePath = result.filePath;
          this.uploadStatus = true;
          this.uploadText = "File uploadded";
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
        });
    },

    init() {
      let loader = this.$loading.show();

      TrainingApi.getTeachers()
        .then(result => {
          this.teachers = result;

          TrainingTemplate.getTemplates()
            .then(result => {
              this.templates = result;
              loader.hide();
            })
            .catch(err => {
              this.Snackbar.snackbarText = err;
              this.Snackbar.visible = true;
              loader.hide();
            });
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loader.hide();
        });
    },
    create() {
      if (this.$refs.form.validate()) {
        if (!this.item.start || !this.item.end) {
          this.Snackbar.snackbarText = "Enter start and end dates!";
          this.Snackbar.visible = true;
          return;
        }

        var startTime = new Date(this.item.start).getTime();
        var endDate = new Date(this.item.end).getTime();

        if (startTime >= endDate) {
          this.Snackbar.snackbarText = "Start date must be before end date!";
          this.Snackbar.visible = true;
          return;
        }

        if (!this.uploadStatus) {
          this.Snackbar.snackbarText = "Image must be uploaded!";
          this.Snackbar.visible = true;
          return;
        }

        let loader = this.$loading.show();
        TrainingApi.createTraining(this.item)
          .then(result => {
            router.go(-1);
            loader.hide();
          })
          .catch(err => {
            this.Snackbar.snackbarText = err;
            this.Snackbar.visible = true;
            loader.hide();
          });
      } else {
        this.Snackbar.snackbarText = "Fill required fields!";
        this.Snackbar.visible = true;
      }
    }
  }
};
</script>

<style>
</style>
